import { useDeepCompareEffect } from 'react-use';
import {
  DEFAULT_POSITION,
  hasValidCenter,
  type MapCenter,
} from '../logic/mapFocus';
import type { TripMapRefs } from './useTripMapDayFocus';

const COUNTRY_ZOOM = 7;

function frameProducts(map: any, experiences: any[]) {
  const { LatLng, LatLngBounds } = (window as any).google.maps;
  const bounds = new LatLngBounds();

  if (experiences.length === 0) {
    bounds.extend(new LatLng(DEFAULT_POSITION.lat, DEFAULT_POSITION.lng));
  }
  experiences
    .filter((experience) =>
      hasValidCenter({
        lat: experience?.inCity?.lat,
        lng: experience?.inCity?.lon,
      }),
    )
    .forEach((experience) =>
      bounds.extend(
        new LatLng(
          parseFloat('' + experience?.inCity?.lat),
          parseFloat('' + experience?.inCity?.lon),
        ),
      ),
    );
  map.fitBounds(bounds);
}

// Frame the country, else the experiences of the list, until the user picks a
// day or the trip has a saved camera.
export default function useTripMapFraming({
  map,
  experiences,
  defaultCenter,
  mapState,
  tripId,
  refs,
}: {
  map: any;
  experiences: any[];
  defaultCenter: MapCenter;
  mapState: { center?: MapCenter | null; tripId?: string | null };
  tripId: string;
  refs: TripMapRefs;
}) {
  useDeepCompareEffect(() => {
    if (!map || refs.hasUserSelectedDay.current) {
      return;
    }
    if (mapState.tripId === tripId && hasValidCenter(mapState.center)) {
      return;
    }

    if (hasValidCenter(defaultCenter)) {
      map.setCenter(defaultCenter);
      map.setZoom(COUNTRY_ZOOM);
    } else {
      frameProducts(map, experiences);
    }
  }, [experiences, map, defaultCenter, mapState.center, mapState.tripId]);
}
